import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ForSaleIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M1 2V16H23V2H1ZM21 14H3V4H21V14ZM4 17.5117H6V22H4V17.5117ZM18 17.5117H20V22H18V17.5117Z",
    fill: "currentColor"
  }));
}